import { PanelRight, Clock } from 'lucide-react';
import { Creative } from './types';

type Props = {
  offerCreative: Creative;
  onOpen: () => void;
};

const OfferCreativeListItem = ({ offerCreative, onOpen }: Props) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className="w-full text-left cursor-pointer rounded-lg border border-border bg-card p-4 hover:bg-card/80 transition-colors"
      onClick={onOpen}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') onOpen();
      }}
    >
      <div className="flex items-center gap-3 w-full">
        <div className="flex flex-col gap-1 min-w-0 flex-1">
          <span className="text-sm tracking-tight truncate">
            {offerCreative.name}
          </span>
          {(offerCreative.start_date || offerCreative.end_date) && (
            <span className="inline-flex items-center gap-1 self-start px-1.5 py-0.5 rounded-sm bg-amber-500/15 border border-amber-500/30 text-amber-700 dark:text-amber-400 text-xs font-medium">
              <Clock className="size-3 shrink-0" strokeWidth={2.5} />
              Time-gated
            </span>
          )}
        </div>
        <span className="flex items-center justify-center size-9 shrink-0 rounded-md hover:bg-accent">
          <PanelRight className="size-4 text-muted-foreground" />
        </span>
      </div>
    </div>
  );
};

export default OfferCreativeListItem;
